<template>
  <div class="page-config-live-data">
    <!-- Mobile plant selector trigger -->
    <div class="d-md-none px-2 pt-2">
      <button class="btn btn-outline-secondary w-100 mb-2" @click="mobilePlantSelectorOpen = true">
        <i class="bi bi-list me-1"></i>
        Anlage wählen
      </button>
    </div>

    <!-- Mobile offcanvas bottom sheet -->
    <div
      v-if="mobilePlantSelectorOpen"
      class="offcanvas offcanvas-bottom d-md-none show"
      style="height: 65vh; visibility: visible"
      tabindex="-1"
    >
      <div class="offcanvas-header">
        <h5 class="offcanvas-title">Anlage wählen</h5>
        <button type="button" class="btn-close" @click="mobilePlantSelectorOpen = false"></button>
      </div>
      <div class="offcanvas-body overflow-auto">
        <NavPlantsSidebar
          v-if="plantsLoaded"
          v-bind="currentPlantsProperties"
          v-on:setPlant="onMobilePlantSelected"
          v-on:setComponent="onMobileComponentSelected"
        />
      </div>
    </div>
    <div
      v-if="mobilePlantSelectorOpen"
      class="offcanvas-backdrop fade show"
      @click="mobilePlantSelectorOpen = false"
    ></div>

    <div class="col-md-3 col-lg-2 d-none d-md-block bg-light sidebar">
      <NavPlantsSidebar
        v-if="plantsLoaded"
        v-bind="currentPlantsProperties"
        v-on:setPlant="setAnalysePlant"
        v-on:setComponent="setAnalysePlantComponent"
      ></NavPlantsSidebar>
    </div>
    <div class="col-12 col-md-9 ms-sm-auto col-lg-10">
      <template v-if="this.currentPlantComponent">
        <component :is="currentTabComponent" v-bind="currentProperties"></component>
      </template>
    </div>
  </div>
</template>

<script>
import AnalyseForPlant from '@/components/analyse/AnalyseForPlant.vue';
import NavPlantsSidebar from '@/components/navs/NavPlantsSidebar.vue';
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'Analyse',
  components: {
    AnalyseForPlant,
    NavPlantsSidebar,
  },
  data() {
    return {
      currentPlant: '',
      currentPlantComponent: '',
      currentTabComponent: '',
      mobilePlantSelectorOpen: false,
    };
  },
  methods: {
    onMobilePlantSelected(plant) {
      this.setAnalysePlant(plant);
    },
    onMobileComponentSelected(plant, component) {
      this.mobilePlantSelectorOpen = false;
      this.setAnalysePlantComponent(plant, component);
    },
    setAnalysePlant(plant) {
      console.log('entry setAnalysePlant');
      this.currentPlant = plant;
      this.currentPlantComponent = '';
      this.currentTabComponent = 'AnalyseForPlant';
      console.log('exit setAnalysePlant');
    },
    setAnalysePlantComponent(plant, component) {
      console.log('entry setAnalysePlantComponent');
      this.currentPlant = plant;
      this.currentPlantComponent = component;
      this.currentTabComponent = 'AnalyseForPlant';
      console.log('exit setAnalysePlantComponent');
    },
  },
  computed: {
    plantsLoaded() {
      if (this.$store.getters.getPlants) {
        return true;
      }
      return false;
    },
    organisation() {
      return this.$store.getters.getOrganisation;
    },

    currentProperties() {
      return { plant: this.currentPlant, component: this.currentPlantComponent };
    },
    currentPlantsProperties() {
      return {
        plants: this.$store.getters.getPlants,
        showPlantComponents: true,
        editPlantComponents: false,
        editPlants: false,
      };
    },
  },
};
</script>

<style scoped>
/* iOS-style grouped list for mobile offcanvas */
.offcanvas-body {
  background-color: #f2f2f7;
  padding: 0 !important;
}

.offcanvas-body :deep(.nav-sidebar) {
  padding: 12px 16px;
  margin: 0;
}

/* Plant row — bold header item */
.offcanvas-body :deep(.nav-sidebar > .nav-item > .nav-link) {
  background: #fff;
  border-radius: 12px;
  padding: 14px 16px;
  color: #000;
  font-size: 17px;
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.offcanvas-body :deep(.nav-sidebar > .nav-item > .nav-link::after) {
  content: '›';
  font-size: 20px;
  color: #c7c7cc;
  font-weight: 300;
  line-height: 1;
}
.offcanvas-body :deep(.nav-sidebar > .nav-item > .nav-link.active) {
  color: #007aff;
}

/* Sub-nav section inside collapsed plant */
.offcanvas-body :deep(.nav-sidebar .collapse > .nav.flex-column) {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 8px;
}

/* "Komponenten" section label */
.offcanvas-body :deep(.nav-sidebar .collapse > .nav > .nav-item > .nav-link) {
  padding: 10px 16px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8e8e93;
  background: transparent;
  border-bottom: 0.5px solid #e5e5ea;
}
.offcanvas-body :deep(.nav-sidebar .collapse > .nav > .nav-item > .nav-link::after) {
  display: none;
}

/* Individual component rows */
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3) {
  padding: 0 !important;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-link) {
  padding: 14px 16px;
  font-size: 16px;
  font-weight: 400;
  color: #000;
  text-decoration: none;
  border-bottom: 0.5px solid #e5e5ea;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-link::after) {
  content: '›';
  font-size: 20px;
  color: #c7c7cc;
  font-weight: 300;
  flex-shrink: 0;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-item:last-child .nav-link) {
  border-bottom: none;
}
.offcanvas-body :deep(.nav-sidebar .collapse .ps-3 .nav-link.active) {
  color: #007aff;
  background-color: #f0f5ff;
}

/* Remove Bootstrap's offset/padding from sub-lists */
.offcanvas-body :deep(.nav-sidebar .offset-1) {
  margin-left: 0 !important;
}
</style>
